import React from 'react';
import {
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Button } from 'reactstrap';
import propTypes from 'prop-types';

export const KEYWORD_MAX_LENGTH = 255;

const SearchForm = props => (
  <Form onSubmit={props.onSubmit}>
    <FormGroup className="mb-0">
      <InputGroup>
        <Input
          type="text"
          name="keyword"
          id="customer_review_keyword"
          aria-label="Search reviews"
          placeholder="Search invoice, SKU, product, or buyer email..."
          maxLength={KEYWORD_MAX_LENGTH}
          value={props.keyword}
          onChange={props.onInputChange}
        />
        <InputGroupAddon addonType="append">
          <Button color="primary" disabled={props.isLoading}>Search</Button>
        </InputGroupAddon>
      </InputGroup>
    </FormGroup>
  </Form>
)

export default SearchForm;

SearchForm.propTypes = {
  keyword: propTypes.string,
  isLoading: propTypes.bool,
  onInputChange: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired
}

SearchForm.defaultProps = {
  keyword: '',
  isLoading: false
}
